export const MAP_API_KEY = 'AIzaSyCqy9aCGs7YeJDqaXjq_JZslaM8KuAxgrk'
